<ng-container *ngIf="viewModel$ | async as viewModel">
    <ng-container *ngIf="viewModel.tabs.length">
        <div class="list tabs-header-wrapper">
            <div class="item-header col-12">{{ sitecore.lobby.NextToGoEvents }}</div>
        </div>
        <ms-sports-tab-bar [sports]="viewModel.tabs" (selectedTab)="tabSelected($event)"></ms-sports-tab-bar>
        <div
            [ngClass]="{
                'next-to-go-events': !isWideScreen || (!showOdds && selectedSportEventsCount > 1),
                'next-to-go-events_odds': isWideScreen && showOdds,
                'next-to-go-events_single': isWideScreen && selectedSportEventsCount === 1 && !showOdds,
            }">
            <ms-next-to-go-event
                *ngFor="let event of viewModel.events; index as i; trackBy: trackOption"
                [event]="event"
                [eventsCount]="selectedSportEventsCount"
                [isWideScreen]="isWideScreen"
                [marketgridGroupIds]="marketGridGroupIds"
                [tracking]="{ source: trackingSource, position: i }"
                [oddsTimerGroupClass]="oddsTimerGroupClass"
                (click)="eventClicked(event, i)">
            </ms-next-to-go-event>
        </div>
        <ms-next-to-go-show-more *ngIf="showExpander" [expand]="expand" (expandChange)="showMoreToggle($event)"></ms-next-to-go-show-more>
    </ng-container>
</ng-container>
